module.exports = __webpack_public_path__ + "img/VEN.5000cd64.svg";